/**
 * `[[TOOLCARD]]` sentinel'lerini metinden ayirip SEGMENT listesi uretir.
 *
 * ## Neden segment, neden HTML string degil
 *
 * Vanilla arayuz `buildToolCard` ile elle HTML string birlestiriyordu ve
 * icinde `b64()`/`atob`/`unescape` gidis-donusu vardi. Segment listesi
 * uretmek uc sey kazandiriyor:
 *   1. Kart bir React bilesenі oluyor; `<CopyButton text={code}/>` string'i
 *      closure'la kapatiyor, base64 gidis-donusu tamamen yok oluyor.
 *   2. Kart icerigi markdown/sanitize hattina HIC girmiyor.
 *   3. KAPANMAMIS sentinel gizlenebiliyor (asagida).
 *
 * ## Kapanmamis sentinel GIZLENIYOR
 *
 * Akis ortasinda `[[TOOLCARD]]{"kind":...` yarim gelebiliyor. Onu metin
 * olarak gostermek kullaniciya ham JSON parcasi gostermek demek. Kapanana
 * kadar o kisim HIC render edilmiyor.
 *
 * ## Sentinel gecici
 *
 * Sunucu ayni bilgiyi `toolcard` SSE olayi olarak da gonderiyor ve o
 * TAKLIT EDILEMEZ - kullaniciya ait bir sistem prompt'u modele sahte bir
 * kart uretmesini soyleyebilir, bant ici sentinel bunu ayirt edemez.
 * Sentinel yalnizca gecis suresince destekleniyor.
 */

export const TOOLCARD_OPEN = '[[TOOLCARD]]'
export const TOOLCARD_CLOSE = '[[/TOOLCARD]]'

export interface ToolCardData {
  kind: string
  [key: string]: unknown
}

export type Segment =
  | { kind: 'md'; text: string }
  | { kind: 'toolcard'; data: ToolCardData }

/**
 * Metni markdown ve toolcard segmentlerine ayirir.
 *
 * Kapanmamis bir sentinel varsa o noktadan SONRASI atiliyor (henuz
 * gosterilebilir degil).
 */
export function toSegments(text: string): Segment[] {
  const segments: Segment[] = []
  let rest = text

  while (true) {
    const openAt = rest.indexOf(TOOLCARD_OPEN)
    if (openAt === -1) {
      if (rest) segments.push({ kind: 'md', text: rest })
      break
    }

    const before = rest.slice(0, openAt)
    if (before) segments.push({ kind: 'md', text: before })

    const afterOpen = rest.slice(openAt + TOOLCARD_OPEN.length)
    const closeAt = afterOpen.indexOf(TOOLCARD_CLOSE)
    if (closeAt === -1) {
      // KAPANMAMIS: gerisi henuz gosterilemez. Ham JSON parcasi gostermek
      // yerine hic gostermiyoruz.
      break
    }

    const payload = afterOpen.slice(0, closeAt)
    const data = parseCard(payload)
    if (data) {
      segments.push({ kind: 'toolcard', data })
    } else {
      // Bozuk JSON: kartı ATLIYORUZ ama metni kaybetmiyoruz - kullanicinin
      // bir seyler gormesi, sessizce bir bosluk gormesinden iyi.
      segments.push({ kind: 'md', text: payload })
    }

    rest = afterOpen.slice(closeAt + TOOLCARD_CLOSE.length)
  }

  return mergeAdjacentMarkdown(segments)
}

function parseCard(payload: string): ToolCardData | null {
  try {
    const parsed = JSON.parse(payload)
    if (parsed && typeof parsed === 'object' && typeof parsed.kind === 'string') {
      return parsed as ToolCardData
    }
    return null
  } catch {
    return null
  }
}

/**
 * Ardisik markdown segmentlerini birlestirir.
 *
 * Onemli: iki ayri `md` segmenti ayri ayri parse edilirse aralarindaki
 * markdown yapisi (ornegin bir listenin devami) BOLUNUR. Birlestirmek bunu
 * engelliyor.
 */
function mergeAdjacentMarkdown(segments: Segment[]): Segment[] {
  const out: Segment[] = []
  for (const segment of segments) {
    const last = out[out.length - 1]
    if (segment.kind === 'md' && last?.kind === 'md') {
      out[out.length - 1] = { kind: 'md', text: last.text + segment.text }
    } else {
      out.push(segment)
    }
  }
  return out
}
